export enum ArchiveNewsFilter {
    ALL = 'all',
    START = 'start',
    RESULT = 'result',
    OTHER = 'other',
}